export const releaseNotesDe: ReleaseNotes = [
    {
        release: "1.2.6",
        date: "2026-10-28",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Bei Anmeldungen aus amosWEB wird eine Organisation oder die anmeldende Person einer Gruppenanmeldung nicht mehr als Sorgeberechtigte übernommen."
        }]
    },
    {
        release: "1.2.5",
        date: "2026-10-19",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Eine Unterschrift lässt sich nur noch über „Unterschrift entfernen“ löschen."
        }]
    },
    {
        release: "1.2.4",
        date: "2026-10-19",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Das Abschicken eines unterschriebenen Freizeitpasses endet bei formatierten Fragetexten aus amosWEB nicht mehr mit einem Fehler."
        }]
    },
    {
        release: "1.2.3",
        date: "2026-10-09",
        tags: [],
        type: "bugfix",
        notes: [{
            "description": "Die interne Fehlerüberwachung wurde erweitert."
        }]
    },
    {
        release: "1.2.2",
        date: "2026-10-01",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Das Krisenteam hat nur noch während eines aktiven Notfalls Zugriff auf die Daten der Veranstaltung."
        }, {
            "description": "Ein deaktivierter Zugangslink gibt auch in bereits geöffneten Sitzungen keine Daten mehr frei."
        }, {
            "description": "Die Unterschrift per Link ist besser gegen unbefugten Zugriff geschützt."
        }, {
            "description": "Bei einer Anmeldung durch eine Organisation wird keine alternative Ansprechperson mehr gesetzt."
        }, {
            "description": "Die Teilnehmendenliste zeigt, ob eine alternative Ansprechperson aktiv ist."
        }, {
            "description": "Fehlgeschlagene E-Mails sind im Dashboard direkt richtig sortiert."
        }]
    },
    {
        release: "1.2.1",
        date: "2026-09-28",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Kontaktdaten und Adresse der Sorgeberechtigten werden wieder vollständig angezeigt."
        }, {
            "description": "Der Teilnehmenden-Import weist darauf hin, dass CSV-Dateien UTF-8-codiert sein müssen."
        }]
    },
    {
        release: "1.2.0",
        date: "2026-09-16",
        tags: [],
        type: "minor",
        notes: [{
            "description": "Veranstaltungen werden über einen gemeinsamen Button angelegt, der amosWEB-Import ist direkt im Formular erreichbar."
        }, {
            "description": "Die Anzahl der Teilnehmenden einer Gruppe öffnet die auf diese Gruppe gefilterte Teilnehmendenliste."
        }, {
            "description": "Teilnehmende lassen sich als PDF mit einem QR-Code zum Freizeitpass je Person exportieren."
        }, {
            "description": "Der Excel-Export der Teilnehmenden enthält den persönlichen Link zum Freizeitpass."
        }, {
            "description": "Beim Excel-Import von Teilnehmenden lässt sich angeben, wer Teamer ist."
        }],
        fixes: [{
            "description": "Veranstaltungen laden in der App wieder schneller."
        }, {
            "description": "Bei Gruppenanmeldungen aus amosWEB bleibt die alternative Ansprechperson ausgeschaltet."
        }, {
            "description": "Vor- und Nachname stehen im PDF des Freizeitpasses in den richtigen Feldern."
        }, {
            "description": "Der Einleitungstext des Freizeitpasses wurde korrigiert."
        }, {
            "description": "Sichtbarkeitsregel, Export und Aktivitäten verwenden einheitlich die Bezeichnung „Teamer“."
        }, {
            "description": "Die Spalte „Gruppen“ im Teilnehmenden-Export ist korrekt beschriftet."
        }]
    },
    {
        release: "1.1.0",
        date: "2026-09-03",
        tags: [],
        type: "minor",
        notes: [{
            "description": "Teilnehmergruppen und Gruppenzugänge werden für die App bereitgestellt."
        }, {
            "description": "Leitungen können mit der neuen App Gruppen verwalten und Teilnehmende zuordnen."
        }, {
            "description": "Veranstaltungen mit vielen Freizeitpässen laden in der App schneller."
        }],
        fixes: [{
            "description": "Gruppenänderungen im Web werden beim nächsten Datenabgleich in der App übernommen."
        }]
    },
    {
        release: "1.0.0",
        date: "2026-08-11",
        tags: [],
        type: "major",
        notes: [{
            "description": "Teilnehmende lassen sich in Gruppen einteilen, farblich kennzeichnen, filtern und exportieren."
        }, {
            "description": "Für einzelne Gruppen können eigene Zugangslinks für Leitungen vergeben werden."
        }, {
            "description": "Eine Sichtbarkeits-Regel kann eine Frage abhängig von der Gruppe der teilnehmenden Person ein- und ausblenden."
        }, {
            "description": "Die Teilnehmendenliste lässt sich nach den Antworten auf eigene Fragen filtern."
        }, {
            "description": "Freizeitpässe können automatisch zu einem festgelegten Termin versendet werden, auch an später hinzugefügte Teilnehmende."
        }, {
            "description": "In der externen Ansicht werden nur die Fragen angezeigt, die die Person beim Ausfüllen gesehen hat."
        }, {
            "description": "Die externe Ansicht des Freizeitpasses ist übersichtlicher gestaltet und lässt sich durchsuchen."
        }, {
            "description": "Im Verlauf einer teilnehmenden Person ist nachvollziehbar, wer per Massen-SMS benachrichtigt wurde."
        }, {
            "description": "Beim Beenden einer Notfallsituation wird eine Entwarnung versendet."
        }, {
            "description": "Warnungen der amosWEB-Synchronisation sind von echten Fehlern unterscheidbar."
        }],
        fixes: [{
            "description": "Ein Zugangslink für einen einzelnen Freizeitpass zeigt nun ausschließlich diesen einen Freizeitpass."
        }, {
            "description": "Zugangslinks zeigen nun ausschließlich die Veranstaltung, für die sie vergeben wurden."
        }, {
            "description": "Ausgeblendete Teilnehmende und Gruppen sperren ihren Zugangslink nun vorübergehend statt dauerhaft."
        }, {
            "description": "Eine Auswahl in der Teilnehmendenliste wird beim Wechsel der Veranstaltung nun zurückgesetzt."
        }, {
            "description": "SMS werden bei einer Störung des Versanddienstes nun erneut zugestellt."
        }, {
            "description": "Umfangreiche amosWEB-Synchronisationen laufen nun ohne Sperrkonflikte durch."
        }, {
            "description": "Die Verbindung zu amosWEB lässt sich wieder zuverlässig trennen und neu herstellen."
        }, {
            "description": "Beim Import aus amosWEB lassen sich einzelne Teilnehmende wieder abwählen."
        }, {
            "description": "Eine Frage kann nicht mehr doppelt unter derselben Kennung angelegt werden."
        }, {
            "description": "Beim Kopieren in einen Fragensatz wird eine nicht übertragbare Sichtbarkeits-Regel nun entfernt."
        }, {
            "description": "Der Verlauf eines Nutzerkontos zeigt Änderungen nun wieder an."
        }, {
            "description": "Die Pool-Fragen melden beim Öffnen keine ungespeicherten Änderungen mehr."
        }, {
            "description": "Auswahllisten werden im Werkzeug-Bereich nicht mehr abgeschnitten."
        }]
    },
    {
        release: "0.10.7",
        date: "2026-08-06",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Beim Wechsel zwischen den Reitern eines Freizeitpasses gehen nicht gespeicherte Eingaben nicht mehr verloren."
        }]
    },
    {
        release: "0.10.6",
        date: "2026-08-06",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "In der App fehlen keine Antworten mehr zu Fragen, die in eine andere Gruppe verschoben wurden."
        }, {
            "description": "Beim Verschieben zwischen Gruppen wird eine Frage verschoben statt ein zweites Mal angelegt."
        }, {
            "description": "Wird eine Gruppe gelöscht, bleiben bereits beantwortete Fragen samt Antworten erhalten und rücken eine Ebene nach oben."
        }, {
            "description": "Änderungen am Fragebogen sind in der App sofort sichtbar."
        }, {
            "description": "Leitungen im selben Netzwerk blockieren sich beim Anfordern eines SMS-Codes nicht mehr gegenseitig."
        }]
    },
    {
        release: "0.10.5",
        date: "2026-07-31",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Unterschriebene Freizeitpässe melden keine Abweichung mehr, wenn sich an den Antworten nichts geändert hat."
        }, {
            "description": "Unveränderte Antworten erzeugen bei der amosWEB-Synchronisation keine täglichen Historien-Einträge mehr."
        }, {
            "description": "Eine von Hand eingetragene E-Mail-Adresse wird von der amosWEB-Synchronisation nicht mehr überschrieben."
        }]
    },
    {
        release: "0.10.4",
        date: "2026-07-29",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Beim Wechsel zwischen Veranstaltungen werden keine Daten der zuvor geöffneten Veranstaltung mehr übernommen."
        }]
    },
    {
        release: "0.10.3",
        date: "2026-07-27",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Reihenfolge der Fragen bleibt bei der amosWEB-Synchronisation erhalten."
        }, {
            "description": "Einzeln aus amosWEB übertragene Fragen löschen keine anderen Fragen mehr."
        }, {
            "description": "Übertragung einzelner Fragen aus amosWEB (Anlegen, Ändern, Löschen) funktioniert wieder."
        }, {
            "description": "Fehlgeschlagene amosWEB-Anfragen erscheinen im Synchronisations-Protokoll."
        }]
    },
    {
        release: "0.10.2",
        date: "2026-07-24",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Manuell ausgeblendete Teilnehmer werden bei der amosWEB-Synchronisation nicht mehr als sichtbare Dubletten neu angelegt und bleiben zuverlässig ausgeblendet."
        }, {
            "description": "Folgefehler mit ausgeblendeten Teilnehmern behoben: Synchronisation, Änderungsprotokoll und Hintergrund-Aufträge laufen wieder stabil."
        }, {
            "description": "Hausnummern im Zahlenformat aus Importdateien werden korrekt übernommen."
        }]
    },
    {
        release: "0.10.1",
        date: "2026-07-20",
        tags: [],
        type: "bugfix",
        notes: [{
            "description": "Verbesserter Fragen-Abgleich mit amosWEB anhand der aktualisierten Zuordnung der Fragetypen (inkl. Blöcken, Textfeldern und Seitenumbrüchen)."
        }],
        fixes: [{
            "description": "Antworten auf interne Fragen lassen sich wieder korrekt löschen und ändern."
        }, {
            "description": "Fehlendes Teilnahmealter im Formular ergänzt."
        }, {
            "description": "Auswahloptionen von Fragen gehen beim Bearbeiten nicht mehr verloren."
        }]
    },
    {
        release: "0.10.0",
        date: "2026-07-14",
        tags: [],
        type: "minor",
        notes: [{
            "description": "Interne Fragen: nur intern sichtbar, nicht im Online-Formular oder PDF-Export enthalten."
        }, {
            "description": "Anzeige und Filter, ob der Freizeitpass bereits versendet wurde."
        }, {
            "description": "Übersicht der zugeordneten Veranstaltungen je Krisenmanager."
        }, {
            "description": "Stabileres und sichereres Login der Mobile-App."
        }],
        fixes: [{
            "description": "Ungültige Mobilnummern bei Unterschriften werden abgefangen."
        }]
    },
    {
        release: "0.9.6",
        date: "2026-07-07",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Ungültige Zustände von Freizeitpässen."
        }, {
            "description": "Ungültige Verschachtelung von Gruppenfragen."
        }, {
            "description": "Fehlertoleranz bei Antworten erhöht."
        }, {
            "description": "Fehlender Filter bei Auswahl von Gruppenfragen aus Fragen-Pool innerhalb bestehender Gruppen."
        }]
    },
    {
        release: "0.9.5",
        date: "2026-06-24",
        tags: [],
        type: "bugfix",
        notes: [{
            "description": "Export von Nutzerdaten."
        }],
        fixes: [{
            "description": "Löschen von Nutzern erweitert."
        }, {
            "description": "Fehler im Teilnehmenden-Export."
        }, {
            "description": "Kritischer Fehler beim Speichern eines Freizeitpass als neues Frage-Set."
        }]
    },
    {
        release: "0.9.4",
        date: "2026-06-18",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Eingabe ungültiger Mobilnummern abgefangen."
        }, {
            "description": "Fehler durch falsch formatierte Importdaten."
        }, {
            "description": "Fehler in Logs durch Leitungszugänge."
        }]
    },
    {
        release: "0.9.3",
        date: "2026-06-10",
        tags: [],
        type: "bugfix",
        notes: [{
            "description": "Optimierter Import von Teilnehmenden."
        }, {
            "description": "Export von Organisationsdaten."
        }, {
            "description": "Neues Dashboard Widget 'Apps'."
        }],
        fixes: [{
            "description": "Unstimmiger Kontext von Krisenmanagern entfernt."
        }, {
            "description": "Freizeitpass-Mails wurden nicht korrekt an Teilnehmende mit alternativen Ansprechpersonen versendet."
        }]
    },
    {
        release: "0.9.2",
        date: "2026-05-28",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Erweiterung App um Krisenmanager."
        }, {
            "description": "Automatische Mail-Anhänge angepasst."
        }, {
            "description": "Sicherheitsupdates und Optimierungen."
        }]
    }, {
        release: "0.9.1",
        date: "2026-05-20",
        tags: [],
        type: "bugfix",
        fixes: [{
            "description": "Fehler in SMS Versand ohne Telefonnummer."
        }, {
            "description": "Fehlende Daten für Krisenmanager."
        }, {
            "description": "Veraltete Darstellungen entfernt."
        }]
    }, {
        release: "0.9.0",
        date: "2026-05-13",
        tags: [
            "Krisenmanager", "Onlineformular", "SMS"
        ],
        type: "minor",
        notes: [{
            "description": "Umstellung Auswahl Krisenmanager."
        }, {
            "description": "Neue 'Einstellungen' Seite 'Krisenmanager'."
        }, {
            "description": "Datenschutz-Link für Online-Formulare."
        }, {
            "description": "Veranstalter-Daten in Online-Formular und PDF."
        }, {
            "description": "Verbesserte Validierungen."
        }, {
            "description": "Tracking von Login-Zeiten."
        }, {
            "description": "Weitere Optimierungen im SMS Tracking."
        }]
    }, {
        release: "0.8.2",
        date: "2026-03-13",
        tags: [],
        type: "bugfix",
        fixes: [
            {
                "description": "SMS Tracking Probleme."
            },
        ]
    }, {
        release: "0.8.1",
        date: "2026-03-04",
        tags: [],
        type: "bugfix",
        fixes: [
            {
                "description": "Exportprobleme mit Fragen innerhalb Gruppen."
            },
        ]
    }, {
        release: "0.8.0",
        date: "2026-02-17",
        tags: [
            "App", "Logging"
        ],
        type: "minor",
        notes: [
            {
                "description": "Anpassungen von Darstellungen in der App."
            }, {
                "description": "Erweitertes Loggin und Analyse Tools."
            }
        ],
        fixes: [
            {
                "description": "Fehler beim Aktivieren des amosWEB Addons."
            },
        ]
    }, {
        release: "0.7.9",
        date: "2026-01-23",
        tags: [
            "Massenalarm", "Historie"
        ],
        type: "bugfix",
        notes: [{
            "description": "Weitere Funktionen für Notfälle und Massenalarme."
        }, {
            "description": "Auswahl Empfängergruppen bei Massenalarm."
        }, {
            "description": "Erweiterte Historie für Notfälle."
        }, {
            "description": "Nutzerdaten um Telefonnummern erweitert."
        }],
        fixes: [{
            "description": "Länge von Antworten begrenzt, um amosWEB Sync zu gewährleisten."
        }, {
            "description": "Anzeige veralteter Seitentitel behoben."
        }, {
            "description": "Konflikt durch gesperrte Fragen."
        }, {
            "description": "App: Fehler bei gefilterten Antworten."
        }]
    }, {
        release: "0.7.8",
        date: "2026-01-12",
        tags: [
            "Notfälle", "Sichtbarkeiten"
        ],
        type: "bugfix",
        notes: [
            {
                "description": "Sichtbarkeiten von Fragen auch in PDF aufgenommen."
            }, {
                "description": "Neue Variable für Leitungsmails mit Link zur Webansicht der Veranstaltung."
            }, {
                "description": "Neueste Unterschriften in Historie aufgenommen."
            }, {
                "description": "Teilnehmenden XLSX Export erweitert."
            }, {
                "description": "Verbesserungen der Webansicht für Krisenmanager und Leitungen."
            }, {
                "description": "Erweiterung der Daten in Notfall-Mails an Krisenmanager."
            }
        ],
        fixes: [{
            "description": "Textanpassungen für automatische Mails und SMS."
        }, {
            "description": "Fehler beim Auflösen von Variablen in Mails."
        }]
    }, {
        release: "0.7.7",
        date: "2025-12-22",
        tags: [
            "Registrierung",
            "Historie",
            "Mails"
        ],
        type: "bugfix",
        notes: [
            {
                "description": "Anpassungen Registrierung für Organisation."
            }, {
                "description": "Historie um Namen temporärer Zugänge erweitert."
            }, {
                "description": "Weitere Platzhalter für Mails an Leitungen."
            }, {
                "description": "Neuer Schnellfilter für ausstehende Freizeitpässe."
            }
        ],
        fixes: [{
            "description": "Anzeige Bilder in Editoren behoben."
        }, {
            "description": "Überfällige Erinnerungen in 'Erinnert am' Zeitstempel aufgenommen."
        }, {
            "description": "Gruppenanmeldende sollten nicht automatisch als alternative Ansprechperson gesetzt werden."
        }]
    }, {
        release: "0.7.6",
        date: "2025-12-09",
        tags: [
            "Mails", "Onlineformular", "SMS"
        ],
        type: "bugfix",
        notes: [
            {
                "description": "Fehler im Onlineformular deutlicher kommuniziert."
            },
            {
                "description": "Mailvorlagen und verfügbare Variablen erweitert."
            },
            {
                "description": "Weitere Standardwerte angepasst."
            },
            {
                "description": "Zusätzliche SMS bei überfälligen Pässen."
            },
            {
                "description": "Mailvorlagen über Tabelle Organisation > E-Mails verwaltbar."
            },
        ],
        fixes: [
            {
                "description": "Probleme im Mailversand behoben."
            },
            {
                "description": "Auflistung existierender Länder behoben."
            },
            {
                "description": "Fehlende Anzeige von Beschreibungen behoben."
            },
            {
                "description": "Sortierung der Fragen in amosWEB Import behoben."
            },
        ]
    }, {
        release: "0.7.5",
        date: "2025-12-03",
        tags: [
            "Teilnehmende", "Onlineformular", "Sicherheit"
        ],
        type: "bugfix",
        notes: [
            {
                "description": "Erhöhte Sicherheit im Onlineformular."
            },
            {
                "description": "Anzeige offene Fehler im Onlineformular."
            },
            {
                "description": "Teilnehmende um Daten 'Ansprechperson' erweitert."
            },
            {
                "description": "Erweiterung geschützte amosWEB Daten."
            },
            {
                "description": "Anpassungen Standardwerte."
            },
        ],
        fixes: [
            {
                "description": "Bemerkungen zu Fragen wurden nicht angezeigt."
            },
        ]
    }, {
        release: "0.7.4",
        date: "2025-11-24",
        tags: [
            "Onlineformular", "Teilnehmende"
        ],
        type: "bugfix",
        notes: [
            {
                "description": "Geburtsdatum von Teilnehmenden im Onlineformular nicht mehr anpassbar."
            },
            {
                "description": "Pflichtfelder von Sorgeberechtigten / Notfallkontakten im Onlineformular angepasst."
            },
            {
                "description": "Neues Feld in Notfallkontakte hinzugefügt."
            },
            {
                "description": "Neue Frageart 'Text' für längere Texte im Onlineformular."
            },
            {
                "description": "Anzeige verbleibender Zeichen in Textfeldern im Onlineformular."
            },
        ],
        fixes: [
            {
                "description": "Einige Schreibfehler behoben und Wording angepasst."
            },
        ]
    }, {
        release: "0.7.3",
        date: "2025-11-19",
        tags: [
            "Onlineformular", "Freizeitpass"
        ],
        type: "bugfix",
        notes: [
            {
                "description": "Teilnehmende können nun im Onlineformular ihren Freizeitpass herunterladen."
            },
            {
                "description": "Neue Frageart 'Seitenumbruch' für PDF Layouting."
            },
            {
                "description": "Notfallkontakte in Freizeitpass PDF hinzugefügt."
            },
        ],
        fixes: [
            {
                "description": "Inkorrekte Darstellungen im Dashboard."
            },
            {
                "description": "SMS wurden nicht versendet."
            },
        ]
    }, {
        release: "0.7.2",
        date: "2025-11-10",
        tags: [
            "System", "Anbindungen"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Veraltete CMS Funktionen entfernt"
            },
            {
                "description": "Ungenutzte Websockets entfernt"
            },
            {
                "description": "Weitere kleinere Fehler behoben"
            },
        ]
    }, {
        release: "0.7.1",
        date: "2025-11-03",
        tags: [
            "Anbindungen"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Fehler bei amosWEB Synchronisationen behoben"
            },
            {
                "description": "Mailversand angepasst"
            },
            {
                "description": "SSO Anmeldung verbessert"
            },
        ]
    }, {
        release: "0.7.0",
        date: "2025-10-30",
        tags: [
            "App"
        ],
        type: "minor",
        notes: [
            {
                "description": "Teilnehmenden Export"
            },
            {
                "description": "Vorbereitung Freizeitpass App"
            },
            {
                "description": "Automatische Archivierung und Löschung"
            },
            {
                "description": "Externe Zugriffsseiten"
            },
            {
                "description": "Antwortdifferenzen bei Unterschriften"
            },
            {
                "description": "Vorschläge in Onlineformularen"
            },
            {
                "description": "Komplette Datenverschlüsselung"
            },
            {
                "description": "Temporäre Zugänge pro Teilnehmende"
            },
            {
                "description": "2FA Unterschrift per SMS"
            },
            {
                "description": "System Abrechnungen"
            },
            {
                "description": "Fehlerlogs für Synchronisationen"
            },
        ],
        fixes: [
            {
                "description": "SMS wurden nicht versendet"
            },
        ]
    }, {
        release: "0.6.0",
        date: "2025-08-07",
        tags: [
            "System"
        ],
        type: "minor",
        notes: [
            {
                "description": "Krisenmanager in Veranstaltungen"
            },
            {
                "description": "Anpassung der Globalen Suche"
            },
            {
                "description": "Fertigstellung der amosWEB Anbindung"
            },
            {
                "description": "Detailarbeit in der Darstellung"
            },
            {
                "description": "Teilnahme-Import per CSV/Excel"
            },
            {
                "description": "Dauerprozesse für Abrechnungen"
            },
            {
                "description": "System Stammdaten"
            },
            {
                "description": "Erinnerungs-Management"
            },
            {
                "description": "Erweiterung Mailvorlagen"
            },
        ],
        fixes: [
            {
                "description": "Dopplungen durch amosWEB Importe"
            },
            {
                "description": "'Sonstiges' Option im Onlineformular"
            },
            {
                "description": "Wording Veranstaltung statt Freizeit"
            }
        ]
    }, {
        release: "0.5.0",
        date: "2025-07-17",
        tags: [
            "App"
        ],
        type: "minor",
        notes: [
            {
                "description": "Mailvorlagen und Mail Verwaltung"
            },
            {
                "description": "Maileinstellungen für Organisationen"
            },
            {
                "description": "App - Offline und Verschlüsselung"
            },
            {
                "description": "Onlineformular Antworten"
            },
            {
                "description": "Onlineformular Unterschriften"
            },
            {
                "description": "Fragesets in Freizeiterstellung"
            },
            {
                "description": "Validierung und Formatierung von Mobilnummern"
            },
            {
                "description": "Einladungslinks Leitungen"
            }
        ]
    }, {
        release: "0.4.0",
        date: "2025-07-01",
        tags: [
            "Onlineformular"
        ],
        type: "minor",
        notes: [
            {
                "description": "App Layout und Anmeldung"
            },
            {
                "description": "Onlineformular mit Authentifizierung"
            },
            {
                "description": "CMS und Landingpage"
            },
            {
                "description": "Frageart Gruppe implementiert"
            },
            {
                "description": "Sichtbarkeiten überarbeitet"
            },
            {
                "description": "amosWEB Fragen-Verbindungen"
            },
        ]
    }, {
        release: "0.3.0",
        date: "2025-06-06",
        tags: [
            "Freizeitpass"
        ],
        type: "minor",
        notes: [
            {
                "description": "Verwaltung von Teilnehmenden implementiert"
            },
            {
                "description": "Sorgeberechtigte aufgenommen"
            },
            {
                "description": "Freizeitpass Export eingerichtet"
            },
            {
                "description": "Zu Lucide Icons gewechselt"
            },
            {
                "description": "Historien für Teilnehmende und Veranstaltungen integriert"
            },
            {
                "description": "Einige Optimierungen von Komponenten"
            },
        ]
    }, {
        release: "0.2.0",
        date: "2025-05-28",
        tags: [
            "Stammdaten"
        ],
        type: "minor",
        notes: [
            {
                "description": "App-Layout definiert"
            },
            {
                "description": "Anmeldefragen implementiert"
            },
            {
                "description": "Fragen-Sets verwalten",
            },
            {
                "description": "Veranstaltungs-Grundlagen implementiert",
            },
            {
                "description": "Veranstaltungs-Historie eingerichtet",
            },
            {
                "description": "Verwaltung von Teilnehmenden vorbereitet",
            }
        ]
    }, {
        release: "0.1.0",
        date: "2025-05-14",
        tags: [
            "Grundlagen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Rollen und Fähigkeiten wurden hinzugefügt"
            },
            {
                "description": "Login und Registrierung angelegt"
            },
            {
                "description": "Organisations- und Nutzerverwaltung implementiert"
            },
            {
                "description": "amosWEB RuleBuilder in Grundsystem integriert"
            },
            {
                "description": "amosWEB SSO eingerichtet"
            }
        ]
    }, {
        release: "0.0.1",
        date: "2025-04-03",
        tags: [
            "DEV System"
        ],
        type: "bugfix",
        notes: [
            {
                "description": "Das DEV System wurde aufgesetzt"
            },
            {
                "description": "Das Grundlayout wurde angepasst"
            },
            {
                "description": "Nutzer können nun mehreren Organisationen angehören"
            }
        ]
    }, {
        release: "0.0.0",
        date: "2025-03-31",
        tags: [
            "Projektstart"
        ],
        type: "major",
        notes: [
            {
                "description": "Das Projekt wurde aufgesetzt. Die Entwicklung kann beginnen!"
            }
        ]
    }
]
